export default {"src":"/_next/static/media/MessageLoadingPlaceholder.5a7d04a8.gif","height":100,"width":150,"blurWidth":0,"blurHeight":0};